import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

const FOLDER_COLORS = [
  { id: 'blue', name: 'Azul', hex: '#3B82F6' },
  { id: 'green', name: 'Verde', hex: '#10B981' },
  { id: 'purple', name: 'Roxo', hex: '#8B5CF6' },
  { id: 'orange', name: 'Laranja', hex: '#F59E0B' },
  { id: 'red', name: 'Vermelho', hex: '#EF4444' },
  { id: 'pink', name: 'Rosa', hex: '#EC4899' },
  { id: 'yellow', name: 'Amarelo', hex: '#EAB308' },
  { id: 'teal', name: 'Turquesa', hex: '#14B8A6' },
  { id: 'indigo', name: 'Índigo', hex: '#6366F1' },
  { id: 'gray', name: 'Cinza', hex: '#6B7280' },
];

interface FolderColorSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export function FolderColorSelector({ value, onChange }: FolderColorSelectorProps) {
  return (
    <div className="space-y-2">
      <Label>Cor da Pasta</Label>
      <div className="grid grid-cols-5 gap-2">
        {FOLDER_COLORS.map(({ id, name, hex }) => (
          <button
            key={id}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange(id);
            }}
            className={cn(
              "relative flex items-center justify-center h-12 rounded-md transition-all",
              "border-2 hover:scale-105",
              value === id
                ? "border-foreground scale-105"
                : "border-muted"
            )}
            style={{ backgroundColor: hex }}
            title={name}
          >
            {value === id && (
              <Check className="h-5 w-5 text-white drop-shadow-lg" strokeWidth={3} />
            )}
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        {FOLDER_COLORS.find(c => c.id === value)?.name || 'Selecione uma cor'}
      </p>
    </div>
  );
}
